<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :model="formModel"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="进价修改明细:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                  <span class="red"> 修改进价可能影响财务报表期初数据，请务必获得财务人员确认后再修改！</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <div class="" style="margin-left: 134px;">
                  <lk-table border :columns="columns" :data="formModel.tableData">
                    <template slot-scope="{ row, index }" slot="priceWithTax">
                      <lk-form-item
                        :prop="'tableData.' + index + '.priceWithTax'"
                        :label-width="0"
                        :rules="formRules">
                        <DtpInputNumber
                          clearable
                          placeholder="请输入"
                          :precision="6"
                          @on-change="validFormItem($event, row, index)"
                          v-model="row.priceWithTax">
                        </DtpInputNumber>
                      </lk-form-item>
                    </template>
                  </lk-table>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="商品进价被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQuery.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>验收时间：</label>
          <timeStampDatePicker v-model.trim="modalQuery.createTimeMs" class="item"></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model.trim="modalQuery.goodsBatchNumber" :maxlength="50" placeholder="请输入批号"></lk-input>
        </div>
        <div class="queryItem">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="modalQuery.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.formModel.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import toolsGoodsMixins from '../../mixins/toolsGoodsMixins';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';
import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'PriceWithTaxAdd',
  mixins: [toolsGoodsMixins],
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
    DtpInputNumber,
  },
  data() {
    return {
      formModel: {
        tableData: [],
      },
      formRules: [
        { required: true, message: '请输入...' },
      ],
      submitConfirmVisiable: false,
      submitLoading: false,
      columns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 130,
        },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '批次', key: 'goodsBatchSeq', minWidth: 116 },
	      { title: '原进价', key: 'priceBeforeTax', minWidth: 116 },
	      {
	      	title: '修改后进价',
          slot: 'priceWithTax',
          minWidth: 116,
        },
	      {
		      title: '批准文号',
		      key: 'approvalNumber',
		      minWidth: 116,
	      },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.formModel.tableData.splice(index, 1);
                this.$Message.success('删除成功');
                this.$nextTick(() => {
                  this.$refs.form.validate();
                });
              },
            },
          }, '删除'),
        },
      ],
      modalQuery: {
        nameMix: null,
        createTimeMs: null,
        goodsBatchNumber: null,
        storeIdList: [],
      },
    };
  },
  computed: {},
  methods: {
    handleToList() {
      this.$router.push({
        name: 'priceWithTaxList',
      });
    },
    validSingleItemByIndex(index) {
      this.$refs.form.validateField(`tableData.${index}.priceWithTax`);
    },
    validFormItem(value, item, index) {
      item.priceWithTax = value;
      this.formModel.tableData[index] = item;
      this.$nextTick(() => {
        if (utils.isEmpty(value)) { // 重新触发验证
          this.validSingleItemByIndex(index);
        }
      });
    },
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.modalParams.excludeUnPack = 1;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      this.modalTableData = [];
      inventory.getInventoryData(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = this.exchangeInventoryGoods(item);
            result.priceWithTax = result.priceBeforeTax || 1; // 要修改成的进项税率
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    submit() {
      const params = [];
      this.formModel.tableData.forEach((item) => {
        params.push({
          inventoryId: item.id,
          priceWithTax: item.priceWithTax,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.priceWithTaxUpdateSubmit({ operateInputVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.formModel.tableData.length === 0) {
        this.$Message.error('请先添加明细');
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          let num = 0;
          this.formModel.tableData.forEach((item) => {
            if (item.priceWithTax === item.priceBeforeTax) {
              num++;
              this.$Message.error(`商品编码${item.drugSerialCode}未做任何更改，无需提交`);
            }
          });

          if (num === 0) {
            this.submitConfirmVisiable = true;
          }
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
  .red {
    color: red;
  }
</style>
